// Lib Imports
import 'bootstrap';

import '../sass/main.scss';

import './browser_support';
import './marquee';
import functions from './functions.legacy';

export { functions };
